export const VolumeStorageKey = "volume";
export const VideoSpeedStorageKey = "videoSpeed";
export const MuiSliderSize = "small";
